import React, { createContext, useContext, useState } from 'react';

const ChatbotContext = createContext();

export const useChatbot = () => {
  const context = useContext(ChatbotContext);
  if (!context) {
    throw new Error('useChatbot must be used within a ChatbotProvider');
  }
  return context;
};

export const ChatbotProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('menu');

  const openChatbot = (tab = 'menu') => {
    setActiveTab(tab);
    setIsOpen(true);
  };

  const closeChatbot = () => {
    setIsOpen(false);
  };

  const toggleChatbot = () => {
    setIsOpen(prev => !prev);
  };

  return (
    <ChatbotContext.Provider value={{ 
      isOpen, 
      setIsOpen, 
      activeTab, 
      setActiveTab, 
      openChatbot, 
      closeChatbot, 
      toggleChatbot 
    }}>
      {children}
    </ChatbotContext.Provider>
  );
};

export default ChatbotContext;
